
import React from 'react'

import { FiMinimize, FiMaximize } from 'react-icons/fi'
import { withMicrocopy } from '~contexts/MicrocopyContext'

const ExpandButton = ({
  onClick,
  expanded,
  enabled,
  microcopy
}) => (
  <>
    { enabled && (
      <button onClick={onClick} data-role='button'>
        { expanded ? <FiMinimize /> : <FiMaximize /> }
        <span>{ expanded ? microcopy.text('explorer.buttons.collapse') : microcopy.text('explorer.buttons.expand') }</span>
      </button>
    )}
  </>
)

export default withMicrocopy(ExpandButton)